<template>
  <div class="position-relative pb-5">

    <div class="bg-white shadow-sm p-4 p-md-5 mt-4">
      <LoaderContent v-if="isLoading" :welcomeMessage="false" :alignSpinnerTop="true" />

      <!-- Já está inscrito, mas ainda nåõ finalizou todos os testes -->
      <div class="text-center mb-5" v-if="isEnrolled && !allDone">
        <alert-circle-icon style="font-size:80px;" class="text-red-ml" />
        <h3>Finalize os testes abaixo para continuar sua inscrição</h3>
      </div>

      <!-- Já está inscrito e finalizou todos os testes -->
      <div class="text-center mb-5" v-if="isEnrolled && allDone">
        <h3>Você já está inscrito nessa oportunidade</h3>
      </div>

      <!-- Não está inscrito -->
      <div class="text-center mb-5" v-if="!isEnrolled">
        <alert-circle-icon style="font-size:80px;" class="text-red-ml" />
        <h3>Finalize os testes abaixo para continuar sua inscrição</h3>
      </div>

      <div class="d-flex align-items-center p-3 bg-light-2 shadow-sm mb-4" v-for="(test, i) in tests">
        <file-document-outline-icon class="mr-2" style="font-size:30px;" v-if="test.status == 'pending'" />
        <file-check-outline-icon class="mr-2 text-green-ml" style="font-size:30px;" v-if="test.status == 'finished'" />

        <div class="mr-2">
          <h6>{{ test.name }}</h6>
          <span v-if="test.status == 'pending'">Pendente</span>
          <span v-if="test.status == 'finished'">Finalizado</span>
        </div>

        <button v-if="test.test_id == null && test.status == 'pending'"  @click="alertPrimeiraEscolha(test.url)" class="btn btn-blue-ml ml-auto d-flex align-items-center">
          Começar <chevron-right-icon class="h3 ml-5 mb-0" />
        </button>

        <router-link v-if="test.test_id != null && test.status == 'pending'" :to="redirect(`${test.name}/${test.test_id}`)" class="btn btn-blue-ml ml-auto d-flex align-items-center">
          Começar <chevron-right-icon class="h3 ml-5 mb-0" />
        </router-link>
      </div>
    </div>

    <button @click="subscription()" v-if="canSubmitForm" class="btn-submit btn btn-lg btn-blue-ml mx-auto d-flex align-items-center mt-5">
      <span v-if="!isSaving">Finalizar Inscrição</span>
      <EllipsisLoader v-else />
    </button>

  </div>
</template>

<script>
  import LoaderContent from '@/components/loader/LoaderContent.vue'
  import EllipsisLoader from '@/components/loader/EllipsisLoader.vue'
  import AlertCircleIcon from "vue-material-design-icons/AlertCircle.vue";
  import FileAlertIcon from "vue-material-design-icons/FileAlert.vue";
  import FileCheckIcon from "vue-material-design-icons/FileCheck.vue";
  import FileDocumentOutlineIcon from "vue-material-design-icons/FileDocumentOutline.vue";
  import FileCheckOutlineIcon from '@/components/mlIcons/FileCheckOutline';
  import ChevronRightIcon from "vue-material-design-icons/ChevronRight.vue";

  export default {
    name: 'OnlineTests',

    data() {
      return {
        isLoading: false,
        tests: [],
        message: " ",
        isSaving: false,
        opportunity: null,
        isEnrolled: false
      }
    },

    head(){
      return this.$head({
        title: "",
      });
    },

    computed: {
      opportunityId(){
        const id = this.$route.params.id.match(/\d+/)[0]
        return id
      },

      allDone(){
        return this.tests.filter((test) => test.status == 'pending').length == 0
      },

      canSubmitForm(){
        // Se ele não estiver inscrito ainda
        // E
        // não tem nenhum teste pendente que seja obrigatório na inscrição
        return !this.isEnrolled && this.tests.filter((test) => test.status == 'pending' && test.required_in == 'subscription').length == 0;
      }
    },

    async mounted() {
      this.isLoading = true

      await this.getOpportunity()

      this.$store.dispatch('tests/subscriptionTests', {
        opportunityId: this.opportunityId,
        finishedTests: true,
        requiredIn: 'subscription'
      }).then(tests => {
        this.tests = tests.subscriptionTests.json || []
        this.isLoading = false

        if(this.tests.length == 0) this.subscription();
      }).catch(error => {
      })

      this.$store.dispatch('opportunities/isEnrolled', { opportunityId: this.opportunityId } ).then(response => {
        this.isEnrolled = response.length > 0
      });
    },

    components: {
      LoaderContent,
      EllipsisLoader,
      AlertCircleIcon,
      FileAlertIcon,
      FileCheckIcon,
      FileDocumentOutlineIcon,
      FileCheckOutlineIcon,
      ChevronRightIcon
    },

    methods: {
      async getOpportunity(){
        const opportunity = await this.$store.dispatch('opportunities/getOpportunity', this.$route.params.id.match(/\d+/)[0])
        if( opportunity ){
          this.opportunity = opportunity
        }

        return opportunity
      },

      alertPrimeiraEscolha(link){
        this.$swal({
          title: 'Atenção',
          text: 'Você será direcionado para o site Primeira Escolha para realizar o teste.',
          type: 'info',
          showCancelButton: true,
          cancelButtonText: 'Fechar',
          confirmButtonText: 'Vamos lá!',
          reverseButtons: true
        }).then((result) => {
          if (result.value) {
            window.location.href = link
          }
        })
      },

      redirect(testId){
        return `${ testId }`
      },

      subscription(){
        this.isSaving = true
        const opportunityId = this.$route.params.id.match(/\d+/)[0];
        const opportunity_questions = JSON.parse(localStorage.getItem('opportunity_questions'));

        if(!opportunity_questions || opportunity_questions.error == true){
          this.$router.push(`/vagas/${ this.$route.params.id }/inscricao`);
          return;
        }

        const hasSource = localStorage.getItem('source');
        const indicationForm = localStorage.getItem('indication_form');

        this.$store.dispatch('opportunities/subscriptionNew', {
          opportunity_id: opportunityId,
          questions: opportunity_questions.data.questions,
          source: hasSource ? hasSource : this.$store.state.source,
          indication_form: hasSource && indicationForm ? JSON.parse(indicationForm)['data'] : null,
          send_confirmed_email: true
        }).then( data => {
          this.isSaving = false

          if(data.error){
            if(data.error.message){
              this.$swal('Uoops', data.error.message, 'error');
            }else{
              this.$swal('Uoops', 'Ocorreu um erro ao processar sua candidatura... Tente novamente mais tarde.', 'error');
            }
            this.$router.push(`/vagas/${ this.$route.params.id }/inscricao`);
          }else{
            if(hasSource) localStorage.removeItem('source');
            if(indicationForm) localStorage.removeItem('indication_form');
            this.$store.commit('user/SET_FOLLOWER', true);
            this.$router.push(`/inscricao-confirmada?vaga=${this.opportunity.title}&id=${opportunityId}`);
          }
        })
      }
    },
  }
</script>
<style lang="scss" scoped>
</style>
